import React from 'react';
import { SyncOutlined, CloseOutlined } from '@ant-design/icons';
import { useThemeMode } from '../../contexts/ThemeContext';

/**
 * SyncToast — Floating bottom-right toast for background data sync status.
 * Usage: <SyncToast visible={isDataSyncing && !dismissed} onDismiss={() => setDismissed(true)} />
 */
const SyncToast = ({ visible, onDismiss }) => {
    const { themeMode } = useThemeMode();
    const isDark = themeMode === 'dark';

    if (!visible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '24px',
                right: '24px',
                zIndex: 1050,
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                background: 'var(--app-surface)',
                border: '1px solid var(--app-border)',
                borderLeft: '4px solid #1677ff',
                borderRadius: '10px',
                padding: '14px 16px',
                boxShadow: isDark ? '0 6px 24px rgba(0,0,0,0.45)' : '0 6px 24px rgba(0,0,0,0.10)',
                minWidth: '280px',
                maxWidth: '340px',
                animation: 'slideInToast 0.3s ease',
            }}
        >
            {/* Animated sync icon */}
            <div style={{ marginTop: '2px', flexShrink: 0 }}>
                <SyncOutlined spin style={{ fontSize: '18px', color: '#1677ff' }} />
            </div>

            {/* Text content */}
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: '13px', color: 'var(--app-text)', marginBottom: '3px' }}>
                    Syncing your Amazon data
                </div>
                <div style={{ fontSize: '12px', color: 'var(--app-text-muted)', lineHeight: '1.4' }}>
                    Numbers take 6–48 hours to fully load. We will email you when it’s done.
                    While you wait, add your COGS and expenses—that's the one thing we can't pull from Amazon.
                </div>
            </div>

            {/* Dismiss button */}
            <button
                onClick={onDismiss}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '0',
                    color: 'var(--app-text-muted)',
                    flexShrink: 0,
                    fontSize: '14px',
                    lineHeight: 1,
                    marginTop: '1px',
                }}
                title="Dismiss"
            >
                <CloseOutlined />
            </button>

            {/* Keyframe animation */}
            <style>{`
                @keyframes slideInToast {
                    from { opacity: 0; transform: translateY(16px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

export default SyncToast;